export const endUserAssetTypeOptions = [
  { value: "BUSINESS_CARD", label: "Map Advert" },
  { value: "CAROUSEL", label: "Site Carousel" },
  { value: "ABOUT_US", label: "About us" },
  { value: "PRODUCT", label: "Products" },
  { value: "SERVICE", label: "Services" },
  { value: "CONTRACTS", label: "Contracts" },
  { value: "CONTACT_US", label: "Contact us" },
  { value: "APPRENTICESHIP", label: "Apprenticeships" },
  { value: "VACANCY", label: "Vacancies" },
  { value: "COURSES", label: "Our Courses" },
  { value: "WHY_WORK", label: "Why work for us" },
  { value: "TEAMS_AND_ROLES", label: "Teams and roles" },
  { value: "WORK_EXPERIENCE", label: "Experiences of work" },
  { value: "BLOG", label: "Blog" },
  { value: "IN_THE_PRESS", label: "In the Press" },
  { value: "FULL_MEMBERS", label: "Full Members" },
  { value: "HUB_MEMBERS", label: "Hub Members" },
  { value: "SPONSOR_LOGOS", label: "Sponsor Logos" },
  { value: "ENGAGEMENT_TAB", label: "Dashboard" },
  { value: "RESTORE_MEMBERS", label: "Restore Members" },
  { value: "HOME", label: "Home" },
  { value: "FAVORITES", label: "Favorites" },
  { value: "ORGANIZATION_LOGIN", label: "Organization" },
  { value: "EDIT_PROFILE", label: "Edit Profile" },
  { value: "MICROSITES", label: "Microsites" },
  { value: "USER_LOGIN", label: "User Login" },
  { value: "SEARCH_AND_FILTERS", label: "Search and Filters" },
  { value: "VIEWS", label: "Views" },
  { value: "GENERIC", label: "Generic" },
  // { value: "OTHER", label: "Other" },
];

export const orgAdminAssetTypeOptions = [
  { value: "BUSINESS_CARD", label: "Map Advert" },
  { value: "CAROUSEL", label: "Site Carousel" },
  { value: "ABOUT_US", label: "About us" },
  { value: "PRODUCT", label: "Products" },
  { value: "SERVICE", label: "Services" },
  { value: "CONTRACTS", label: "Contracts" },
  { value: "CONTACT_US", label: "Contact us" },
  { value: "APPRENTICESHIP", label: "Apprenticeships" },
  { value: "VACANCY", label: "Vacancies" },
  { value: "COURSES", label: "Our Courses" },
  { value: "WHY_WORK", label: "Why Work for Us" },
  { value: "TEAMS_AND_ROLES", label: "Teams and Roles" },
  { value: "WORK_EXPERIENCE", label: "Experiences of Work" },
  { value: "BLOG", label: "Blog" },
  { value: "IN_THE_PRESS", label: "In the Press" },
  { value: "GENERIC", label: "Generic" },
  { value: "WHY_APPLY", label: "Why Apply" },

  // { value: "OTHER", label: "Other" },

];

export const partnerAdminAssetTypeOptions = [
  { value: "FULL_MEMBERS", label: "Full Members" },
  { value: "HUB_MEMBERS", label: "Hub Members" },
  { value: "CAROUSEL", label: "Site Carousel" },
  { value: "SPONSOR_LOGOS", label: "Sponsor Logos" },
  { value: "ENGAGEMENT_TAB", label: "Dashboard" },
  { value: "RESTORE_MEMBERS", label: "Restore Members" },
  { value: "GENERIC", label: "Generic" },
  // { value: "OTHER", label: "Other" },
];